import React, { useEffect, useState } from 'react';
import './bugBustOverlay.css';
import bugBust from './bugBustLog';

const BugBustOverlay: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [logs, setLogs] = useState<string[]>(bugBust.getLogs());

  useEffect(() => {
    const unsubscribe = bugBust.subscribe((newLogs) => {
      requestAnimationFrame(() => { 
        setLogs([...newLogs]);
      });
    });
    return () => {
      unsubscribe();
    };
  }, []);
  

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'F9') {
        setVisible(v => !v);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  if (!visible) return null;

  return (
    <div className="debug-overlay">
      <div className="debug-overlay-content">
        <h3>Debug Log</h3>
        <div className="debug-log">
          {logs.map((log, index) => (
            <div key={index}>{log}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BugBustOverlay;
